import { environment } from '../../../environments/environment';
const api_service = `${environment.procertServices}/api`;
const uri_login = 'login';
const uri_home = 'home';
const uri_user = 'users';
const uri_client = 'clients';
const uri_delegation = 'delegations';
const uri_datasource = 'datasources';
const uri_certificate = 'certificates';
const uri_certificatesparameters = 'certificatesparameters';
const uri_certificate_model = 'certificatesmodel';
const uri_model_datasources = 'modeldatasources';
const uri_model_parameter = 'certificatesmodelparameters';
const uri_group = 'certificatesgroups';
const uri_planner = 'certificatesplanning';
const uri_output = 'certificatesoutputs';
const uri_query = 'queries';
const uri_template = 'templates';
const uri_audit = 'audit';
const uri_country = 'countries';

export const APIServices = {
  security: {
    UserADFS: `${api_service}/${uri_login}/UserADFS`,
    logout: `${api_service}/${uri_login}/Logout`,
  },
  home: {
    certificates: `${api_service}/${uri_home}/certificates`,
    queries: `${api_service}/${uri_home}/queries`,
    getCertificatesPerDay: `${api_service}/${uri_home}/GetCertificatesPerDay`,
    getCertificatesOkAndKo: `${api_service}/${uri_home}/GetCertificatesOkAndKo`,
    getCertificatesPendingPublished: `${api_service}/${uri_home}/GetCertificatesPendingPublished`,
    getAverageTimePerCertificate: `${api_service}/${uri_home}/GetAvergatePerCertificate`,
    getCertificatesGenerating: `${api_service}/${uri_home}/GetCertificatesGenerating`,
    getCertificatesQueued: `${api_service}/${uri_home}/GetCertificatesQueued`,
    getCertificatesErrorLastExec: `${api_service}/${uri_home}/GetCertificatesErrorLastExec`,
    getNumberGenerationQueue: `${api_service}/${uri_home}/GetQGenerationsCount`,
    getNumberStorageQueue: `${api_service}/${uri_home}/GetQStoragesCount`,
  },

  users: `${api_service}/${uri_user}`,
  users_employees: `${api_service}/${uri_user}/employees`,
  users_languages: `${api_service}/${uri_user}/languages`,

  clients:  `${api_service}/${uri_client}`,
  countries:  `${api_service}/${uri_country}`,
  timezones:  `${api_service}/${uri_country}/time-zones`,
  usercountries:  `${api_service}/${uri_country}/usercountries`,
  roles:  `${api_service}/roles`,
  languages:  `${api_service}/languages`,
  roles_menus:  `${api_service}/roles/menus`,
  myuser:  `${api_service}/myuser`,
  employees:  `${api_service}/employees`,
  delegations: `${api_service}/${uri_delegation}`,

  datasources: `${api_service}/${uri_datasource}`,
  datasources_model: (id: string | number) => `${APIServices.datasources}/${id}/${uri_certificate_model}`,
  datasource: 
  {
    models: `${api_service}/${uri_datasource}/${uri_certificate_model}`,
    allowed: `${api_service}/${uri_datasource}/allowed`,
    connections: `${api_service}/${uri_datasource}/connections`,
    collections: `${api_service}/${uri_datasource}/collections`,
  },

  certificates: `${api_service}/${uri_certificate}`,
  certificatesversion: `${api_service}/${uri_certificate}/version`,
  certificatesparameters: `${api_service}/${uri_certificatesparameters}`,
  certificates_parameters: (id: string | number) => `${APIServices.certificates}/${id}/${uri_certificatesparameters}`,
  certificates_queries: (id: string | number) => `${APIServices.certificates}/${id}/queries/valid`,

  certificategroups: `${api_service}/${uri_group}`,
  certificatesgroupscertificates: `${api_service}/${uri_group}/${uri_certificate}`,
  certificatesplanning: `${api_service}/${uri_planner}`,
  certificates_planning: (id: string | number) => `${APIServices.certificates}/${id}/${uri_planner}`,
  certificatesplanningdates: `${api_service}/${uri_planner}/dates`,
  certificatesplanningtimes: `${api_service}/${uri_planner}/times`,
  certificatesoutputs: `${api_service}/${uri_output}`,
  certificatesoutputs_certificate: `${api_service}/${uri_output}/${uri_certificate}`,

  models: `${api_service}/${uri_certificate_model}`,
  modelsparameters: `${api_service}/${uri_model_parameter}`,
  modelsparametersmodels: `${api_service}/${uri_model_parameter}/${uri_certificate_model}`,
  models_datasources_first: (id: string | number) => `${APIServices.models}/${id}/${uri_datasource}/first`,
  models_modeldatasources: (id: string | number) => `${APIServices.models}/${id}/${uri_model_datasources}`,

  model: 
  {
    version: `${api_service}/${uri_certificate_model}/version`,
    reset: (id: string | number) => `${APIServices.models}/${id}/reset`,
    reports: (id: string | number) => `${APIServices.models}/${id}/preview-report`,
    queries_valid: (id: string | number) => `${APIServices.models}/${id}/queries/valid`,
    datasource: (id: string | number, datasourceid: string | number) => `${APIServices.models}/${id}/${uri_datasource}/${datasourceid}`,
    datasources: (id: string | number) => `${APIServices.models}/${id}/${uri_datasource}`,
    queries: (id: string | number) => `${APIServices.models}/${id}/${uri_query}`,
    query: (id: string | number, queryid: string | number) => `${APIServices.models}/${id}/${uri_query}/${queryid}`,
  },

  queries: `${api_service}/${uri_query}`,
  query: 
  {
    models: `${api_service}/${uri_query}/${uri_certificate_model}`,
    datasources: `${api_service}/${uri_query}/${uri_datasource}`,
    version: `${api_service}/${uri_query}/version`,
    test: (id: string | number) => `${APIServices.queries}/${id}/test`,
  },
  queries_model: (id: string | number) => `${APIServices.queries}/${id}/${uri_certificate_model}`,

  templates: `${api_service}/${uri_template}`,
  template: 
  {
    file: (id: string | number) => `${APIServices.templates}/${id}/file`,
    certificates: (id: string | number) => `${APIServices.templates}/${id}/${uri_certificate}`,
  },

  logs: `${api_service}/logs`,
  status: `${api_service}/status`,
  audits: `${api_service}/${uri_audit}`,
  versions: `${api_service}/${uri_audit}/versions`,
  auditserror: `${api_service}/${uri_audit}/errors`,

  generates_file: (id: string | number) => `${APIServices.audits}/${id}/file`,
  generates: (id: string | number) => `${APIServices.audits}/${id}/generates`,
};

export const Grid = 
{
  query_datasource: 'QueryDatasource',
  model: 'CertificatesModel',
  datasources: 'Datasources',
  queries: 'Queries',
  templates: 'Templates',
  countries: 'Countries',
  model_datasource: 'DatasourcesInCert',
  group: 'AddGroup'
};